import { Cookie } from "@utils/Cookie";
import { OnAxiosSuccessData, OnSubmitDripFormType } from "./sfd-form.type";
import helpers from "@components/SignUpForm/helpers";

export const formatSuccessData = (
  dataForSubmission: OnSubmitDripFormType["formData"],
  recaptchaToken: string
) => {
  const { railsTimezone } = helpers;

  let timeZone = railsTimezone();

  if (!timeZone) {
    timeZone = "Pacific Time (US & Canada)";
  }

  const testGroupCookie = Cookie.getCookie("TESTGROUP_ID");
  const mpCookie = Cookie.getCookie(process.env.GATSBY_MIXPANEL_ID);
  const promoCode = Cookie.getCookie("PROMOCODE");
  const msclkid = Cookie.getCookie("msclkid");
  const fbclid = Cookie.getCookie("fbclid");
  const li_fat_id = Cookie.getCookie("li_fat_id");
  const consultcall = Cookie.getCookie("consultcall");
  const userIntent = Cookie.getCookie("userIntent");
  const competitoruserIntent = Cookie.getCookie("competitoruserIntent");
  const gclid = Cookie.getCookie("gclid");
  const visitedPricingPage = Boolean(
    JSON.parse(localStorage.getItem("visitedPricingPage") as string)?.value
  );

  const {
    email,
    firstName,
    globalProfessionId,
    lastName,
    otherProfession,
    password,
    phoneNumber,
    termsOfServiceAcceptance,
    clickedPlan,
    kountSessionId,
  } = dataForSubmission;

  const data: OnAxiosSuccessData = {
    kount: {
      kountSessionId: kountSessionId!,
    },
    data: {
      type: "users",
      attributes: {
        firstName,
        lastName,
        email,
        password,
        phoneNumber,
        timeZone,
        globalProfessionId,
        termsOfServiceAcceptance,
        promoCode,
        recaptchaToken,
        ...(testGroupCookie && { analyticsTestGroup: testGroupCookie }),
      },
    },
    tracking: {
      clickedPlan,
      competitoruserIntent,
      consultcall,
      fbclid,
      gclid,
      li_fat_id,
      mpCookie,
      msclkid,
      ...(otherProfession && { otherProfession }),
      otherProfession,
      userIntent,
      ...(visitedPricingPage && { visitedPricingPage }),
    },
  };

  return data;
};
